import authRules from '../authRules';


const postedSchedules = (user) => {
  const { mySchedule, lastPostings } = user.securityLevels;
  if (
    mySchedule >= authRules.postedSchedules.mySchedule
    ) {
      return true;
  } else {
      return false;
    }
  }


export default postedSchedules;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/postedSchedules.js